import * as Yup from 'yup';
import { dialCode, email, fullName, phoneNumber } from 'Utils/validations';

const VoucherAssignToSchema = Yup.object().shape({
  fullName: Yup.string().optional().concat(fullName),
  email: Yup.string().required().concat(email),
  contactNumber: Yup.object({
    dialCode: dialCode.required(),
    number: phoneNumber.required(),
  }).optional(),
})

export default VoucherAssignToSchema;
